export default __webpack_public_path__ + "static/media/women.eb5c49c5.png";